export default __webpack_public_path__ + "static/media/return-icon.098ab0ae.svg";